"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.stats.total': 'Łączne Onboardingi',
    'onboarding.stats.in_progress': 'W Trakcie',
    'onboarding.stats.completed': 'Zakończone',
    'onboarding.stats.avatars_created': 'Utworzone Awatary',
};
